'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _phaserCe = require('phaser-ce');

var _phaserCe2 = _interopRequireDefault(_phaserCe);

var _socket = require('socket.io-client');

var io = _interopRequireWildcard(_socket);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _Player = require('../sprites/Player');

var _Player2 = _interopRequireDefault(_Player);

var _Enemy = require('../sprites/Enemy');

var _Enemy2 = _interopRequireDefault(_Enemy);

var _Banner = require('../texts/Banner');

var _Banner2 = _interopRequireDefault(_Banner);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* globals __DEV__ */


var _class = function (_Phaser$State) {
  _inherits(_class, _Phaser$State);

  function _class() {
    _classCallCheck(this, _class);

    return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }

  _createClass(_class, [{
    key: 'init',
    value: function init() {
      this.socket = io.connect(_config2.default.serverUrl);
      this.socket.emit('player.newPlayer', 'username');
      this.socket.on('player.created', this.playerCreated.bind(this));
      this.socket.on('player.enemyCreated', this.createEnemy.bind(this));
      this.socket.on('player.disconnect', this.destroyPlayer.bind(this));
      this.socket.on('enemy.disconnect', this.destroyEnemy.bind(this));
      this.socket.on('enemy.position', this.updateEnemy.bind(this));
      this.lastTimeSocketCaptured = 0;
      this.socketDelay = 1 / 60;
    }
    /**
     * Load dynamic assets per level
     */

  }, {
    key: 'preload',
    value: function preload() {}
  }, {
    key: 'create',
    value: function create() {

      this.game.physics.startSystem(_phaserCe2.default.Physics.ARCADE);
      this.game.physics.arcade.checkCollision.down = true;

      var level = this.add.image(0, 0, 'level1');
      /**
       * We can get data from the cache
       */
      var cacheImage = this.game.cache.getImage('level1');
      this.game.world.setBounds(0, 0, 3840, 1600);

      this.banner = new _Banner2.default({
        game: this.game,
        x: this.world.centerX,
        y: this.game.height - 180,
        text: 'Phaser\nRealtime games! '
      });
      this.game.add.existing(this.banner);

      this.enemies = this.game.add.group();
      this.enemies.enableBody = true;

      this.music = this.game.add.audio('music');
      this.music.loop = true;
      //this.music.play()

      this.playerLastPosition = {};
    }
  }, {
    key: 'update',
    value: function update() {
      if (!this.player) return;
      this.game.physics.arcade.collide(this.player, this.enemies);

      var currentPlayerPosition = {
        x: this.player.x,
        y: this.player.y,
        legsAngle: this.player.legs.angle,
        legsFrame: this.player.legs.frame,
        torsoFrame: this.player.torso.frame
      };

      if (this.game.time.now > this.lastTimeSocketCaptured && !_lodash2.default.isEqual(this.playerLastPosition, currentPlayerPosition)) {
        this.lastTimeSocketCaptured = this.game.time.now + this.socketDelay;
        this.socket.emit('player.movement', currentPlayerPosition);
      }
    }
  }, {
    key: 'playerCreated',
    value: function playerCreated(_ref) {
      var _this2 = this;

      var player = _ref.player,
          enemies = _ref.enemies;

      this.player = new _Player2.default({
        game: this.game,
        x: player.x,
        y: player.y,
        asset: 'player',
        id: player.id
      });
      _lodash2.default.forEach(enemies, function (enemy) {
        return _this2.createEnemy(enemy);
      });
    }
  }, {
    key: 'createEnemy',
    value: function createEnemy(_ref2) {
      var id = _ref2.id,
          x = _ref2.x,
          y = _ref2.y,
          _ref2$legsAngle = _ref2.legsAngle,
          legsAngle = _ref2$legsAngle === undefined ? 0 : _ref2$legsAngle;

      var newEnemy = this.enemies.add(new _Enemy2.default({
        game: this.game,
        x: x,
        y: y,
        asset: 'player',
        id: id
      }));
      newEnemy.legs.angle = legsAngle;
    }
  }, {
    key: 'updateEnemy',
    value: function updateEnemy(_ref3) {
      var id = _ref3.id,
          x = _ref3.x,
          y = _ref3.y,
          legsAngle = _ref3.legsAngle,
          legsFrame = _ref3.legsFrame,
          torsoFrame = _ref3.torsoFrame;

      var enemy = _lodash2.default.find(this.enemies.children, { id: id });
      if (enemy) {
        enemy.x = x;
        enemy.y = y;
        enemy.legs.angle = legsAngle;
        enemy.legs.frame = legsFrame;
        enemy.torso.frame = torsoFrame;
      }
    }
  }, {
    key: 'destroyPlayer',
    value: function destroyPlayer() {
      this.player.destroy();
    }
  }, {
    key: 'destroyEnemy',
    value: function destroyEnemy(playerId) {
      var enemy = _lodash2.default.find(this.enemies.children, { id: playerId });
      if (enemy) {
        enemy.destroy();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (__DEV__) {
        if (this.player) {
          this.game.debug.spriteInfo(this.player, 32, 32);
          this.game.debug.body(this.player);
        }
        this.enemies.forEachAlive(function (enemy) {
          this.game.debug.body(enemy, 'rgba(255, 0, 0, 0.5)');
        }, this);
      }
    }
  }]);

  return _class;
}(_phaserCe2.default.State);

exports.default = _class;


//////////////////
// WEBPACK FOOTER
// ./src/states/Game.js
// module id = 361
// module chunks = 0